var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteModalicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FEE6E6",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C53434",
    fillRule: "evenodd",
    d: "M15.2 29.6h9.6a2.4 2.4 0 0 0 2.4-2.4v-12h1.2a1.2 1.2 0 1 0 0-2.4h-3.188l-.97-1.776a1.2 1.2 0 0 0-1.053-.624h-6.22c-.518 0-.977.334-1.184.81-.21.484-.516 1.098-.89 1.59H11.6a1.2 1.2 0 0 0 0 2.4h1.2v12a2.4 2.4 0 0 0 2.4 2.4Zm2.4-12a1.2 1.2 0 0 1 1.2 1.2v6a1.2 1.2 0 1 1-2.4 0v-6a1.2 1.2 0 0 1 1.2-1.2Zm4.8 0a1.2 1.2 0 0 1 1.2 1.2v6a1.2 1.2 0 1 1-2.4 0v-6a1.2 1.2 0 0 1 1.2-1.2Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalicon);
export default __webpack_public_path__ + "static/media/deleteModalicon.eef658a19d139cde52a8ebbdf23cc219.svg";
export { ForwardRef as ReactComponent };